import {
    CircularProgress,
    createStyles,
    Theme,
    withStyles,
    WithStyles
} from "@material-ui/core";
import React from "react";

type PictureLoaderProps = WithStyles<typeof styles> & {
    visible: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        pictureLoader: { margin: theme.spacing(5) },
        pictureLoaderWrapper: {
            alignItems: "center",
            backgroundColor: theme.palette.background.overlay,
            bottom: 0,
            display: "flex",
            height: "100%",
            justifyContent: "center",
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
            width: "100%",
            zIndex: 10
        }
    });

function PictureLoader(props: PictureLoaderProps) {
    const classes = props.classes;

    if (!props.visible) {
        return null;
    }

    return (
        <div className={classes.pictureLoaderWrapper}>
            <CircularProgress
                className={classes.pictureLoader}
                color="primary"
            />
        </div>
    );
}

export default withStyles(styles)(PictureLoader);
